import State from '@/helpers/pattern/state';
import {SucursalModel} from "@/models/generales/sucursal";
import {modelIsModified} from "@/helpers/vue-mc";
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';
import SucursalAPI from "@/services/generales/sucursal";
import {scrollToForm} from '@/helpers/form-scroll-to';


/**
 * State Pattern for Sucursal form
 */
export default class SucursalStates extends State{
  /**
   * Class constructor, important pass the required data within the states methods
   * @param {*} data Any type of data that you want available within the states methods
   */
  constructor(data){
    super(data);
  }

  /**
   * General Methods
   */
  base(){
    return {
      clear({$setState}){
        $setState('initial');
      }
      , async askForClear({$data}){
        try{
          const response = await $data.$swal({
            title: $data.$t('view.global.swal.clear.title')
            , text: $data.$t('view.global.swal.clear.text')
            , type: $data.$t('view.global.swal.clear.type')
            , showCancelButton: $data.$t('view.global.swal.clear.showCancelButton')
            , confirmButtonColor: $data.$t('view.global.swal.clear.confirmButtonColor')
            , cancelButtonColor: $data.$t('view.global.swal.clear.cancelButtonColor')
            , confirmButtonText: $data.$t('view.global.swal.clear.confirmButtonText')
            , cancelButtonText: $data.$t('view.global.swal.clear.cancelButtonText')
            , reverseButtons: true
          });
          
          if(response.value){
            this.clear();
          }
          
          return;
        }catch(error){
          console.log(error)
        }
      }
      , async audit(
        {$data}
        , {
          clave , name, email
          , status
          , locationAddress
          , locationCity
          , locationRegionCode
          , locationCountryCode
          , locationPostalCode
          , consecutivoArchivosGenerados
          , numeroComercio
          , comercio
          , nombreArchivoCartRefresh
          , nombreArchivoCartRefreshCarga
          , mcc
        }
      ){
        try{
          auditoriaStates.EditingState({
            clave , name, email
            , status
            , locationAddress
            , locationCity
            , locationRegionCode
            , locationCountryCode
            , locationPostalCode
            , consecutivoArchivosGenerados
            , numeroComercio
            , comercio
            , nombreArchivoCartRefresh
            , nombreArchivoCartRefreshCarga
            , mcc
          });
        }catch(error){
          console.log(error)
        }
      }
      , resetModel({$data}){
        if($data.comercio != undefined)
          $data.sucursal = new SucursalModel({
              locationAddress: $data.comercio.locationAddress
              , locationCity: $data.comercio.locationCity
              , locationRegionCode: $data.comercio.locationRegionCode
              , locationCountryCode: $data.comercio.locationCountryCode
              , locationPostalCode: $data.comercio.locationPostalCode
              , email: $data.comercio.email
              , status: $data.comercio.status
              , name: $data.comercio.name
              , comercio:$data.comercio
              , nombreArchivoCartRefresh: $data.comercio.nombreArchivoCartRefresh
              , nombreArchivoCartRefreshCarga: $data.comercio.nombreArchivoCartRefreshCarga
              , mcc: $data.comercio.mcc
              }
            );
        else
          $data.sucursal = new SucursalModel();
      }
      , resetValidators({$data}){
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({$data}){
        return $data.hasErrors($data.$v.sucursal) || $data.view.action.submit.busy;
      }
      , async load({$data,$setState},{clave}){
        try{
          EventBus.$emit(events.LOADING,$data.view.action.submit.busy=true);
          const response = await SucursalAPI.get({clave:clave});
          scrollToForm();
          return response
        }catch(error){
          console.log(error);
        }finally{
          EventBus.$emit(events.LOADING,$data.view.action.submit.busy=false);
        }
      }
            
    }
  }

  /**
   * States and its methods
   */
  states(){
    return{
      initial:{
        $constructor:function({$data}){
            //Reset Models and validators
            this.resetModel();
            this.resetValidators();
            //View configuration
            $data.view.elem.button.clear.visible=true;
            $data.view.elem.button.audit.visible=false;
            $data.view.elem.input.clave.visible=false;
            $data.view.elem.input.clave.disabled=true;
            $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
            $data.view.elem.button.submit.data.title.current = $data.view.elem.button.submit.data.title.save;
            $data.view.elem.button.submit.permission = 'ROLE_AGREGAR_COMERCIO';
            
        }
        , async submit({$data},{
          clave , name, email
          , status
          , locationAddress
          , locationCity
          , locationRegionCode
          , locationCountryCode
          , locationPostalCode
          , consecutivoArchivosGenerados
          , numeroComercio
          , comercio
          , nombreArchivoCartRefresh
          , nombreArchivoCartRefreshCarga
          , mcc
        }){
          try{
            if(!$data.isAllValid($data.$v)){
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy=true;
            EventBus.$emit(events.LOADING,$data.view.action.submit.busy);
            const response = await SucursalAPI.save({clave:null, name, email
              , status
              , locationAddress
              , locationCity
              , locationRegionCode
              , locationCountryCode
              , locationPostalCode
              , consecutivoArchivosGenerados
              , numeroComercio
              , comercio
              , nombreArchivoCartRefresh
              , nombreArchivoCartRefreshCarga
              , mcc
            });
            $data.view.action.submit.busy=false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.sucursalTable.refreshData();
            return response;
          }catch(error){
            console.log(error)
            return error;
          }finally{
            $data.view.action.submit.busy=false;
            EventBus.$emit(events.LOADING,$data.view.action.submit.busy);
          }
        }
        
      }
      , editing:{
        $constructor:function({$data}, sucursal){
          
          const {
            clave , name, email
            , status
            , locationAddress
            , locationCity
            , locationRegionCode
            , locationCountryCode
            , locationPostalCode
            , consecutivoArchivosGenerados
            , numeroComercio
            , comercio
            , nombreArchivoCartRefresh
            , nombreArchivoCartRefreshCarga
            , mcc
          } = sucursal;
          $data.view.elem.button.clear.visible=true;
          $data.view.elem.button.audit.visible=true;
          $data.view.elem.input.clave.visible=true;
          $data.view.elem.input.clave.disabled=true;
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.data.title.current = $data.view.elem.button.submit.data.title.update;
          $data.view.elem.button.submit.permission = 'ROLE_MODIFICAR_COMERCIO';
          $data.sucursal = new SucursalModel({
            clave , name, email
            , status
            , locationAddress
            , locationCity
            , locationRegionCode
            , locationCountryCode
            , locationPostalCode
            , consecutivoArchivosGenerados
            , numeroComercio
            , comercio
            , nombreArchivoCartRefresh
            , nombreArchivoCartRefreshCarga
            , mcc
          });
          this.resetValidators();
        }
        , async submit({$data, $setState}, sucursal){
          try{
            if(!$data.isAllValid($data.$v)){
              scrollToForm($data)
              return false;
            }
            $data.view.action.submit.busy=true;
            EventBus.$emit(events.LOADING,$data.view.action.submit.busy);
            const response = await SucursalAPI.update(sucursal);
            $data.view.action.submit.busy=false;
            $setState('initial')
            $data.$refs.sucursalTable.refreshData();
            return response;
          }catch(error){
            console.log(error)
            return error;
          }finally{
            $data.view.action.submit.busy=false;
            EventBus.$emit(events.LOADING,$data.view.action.submit.busy);
          }
        }
        , isDisableButtonSubmit({$data}){
          return $data.hasErrors($data.$v.sucursal) 
            || $data.view.action.submit.busy
            || !modelIsModified($data.sucursal)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/generales/comercio/sucursal-states.js